// src/hooks/dashboard/useDashboardExport.js
import { useState, useCallback } from "react";
import { exportDashboardReport } from "../../api/dashboardApi";
import { message } from "antd";

export default function useDashboardExport() {
  const [exporting, setExporting] = useState(false);

  const downloadReport = useCallback(async () => {
    try {
      setExporting(true);
      await exportDashboardReport();
      message.success("Dashboard report downloaded successfully!");
    } catch (error) {
      console.error("Export failed:", error);
      message.error("Failed to download report. Please try again.");
    } finally {
      setExporting(false);
    }
  }, []);

  return { downloadReport, exporting };
}